import { User } from '@/modules/user/user';
import { Device } from '@/modules/device/device';

export class Breadcrumb {

    public static validate(): string[] {
        return [];
    }
    public id!: string;
    public endDate!: Date;
    public deviceId!: string;
    public createdAt!: Date;
    public updatedAt!: Date;
    public stoppedAt!: Date;
    public createdBy?: User;
    public updatedBy?: User;
    public stoppedBy?: User;

    public device?: Device;

    constructor(opt: any) {
        Object.assign(this, opt);
    }
}
